import { atom } from "recoil"
import { defaultValue, OrderDetail } from "./orderDetailState"

export const getPreOrderDetailState = atom<OrderDetail>({
  key: "atoms/paidTeam/getPreOrderDetailState",
  default: defaultValue,
})
